import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-5 sm:px-8 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle weight="fill" size={64} className="text-muted-foreground mx-auto mb-6" />
      <h1 className="text-3xl font-modern font-light mb-3">Checkout cancelled</h1>
      <p className="text-muted-foreground mb-8">No worries — your bag is still saved. Pick up where you left off whenever you're ready.</p>
      <Link to="/cart" className="bg-primary text-primary-foreground px-8 py-3.5 rounded-full font-modern font-medium hover:bg-primary/90 transition-colors" data-testid="cancel-back-cart">Back to bag</Link>
    </div>
  );
}
